<template>
  <div>
    <section v-if="loaded">
      <vue-headful
        title="Alabama Sweet Spots"
        description="Highlighting Alabama’s sweet spots"
        url="https://alabama.travel/sweetspot"/>
      <CampaignHeader :template="template"/>
      <CampaignList v-on:reloadCampaignMap="reloadCampaignMap" v-if="template && template.map_locations && loaded" :templateTitle="template.title ? template.title : ''" :locations="template.map_locations" :headline_title="template.mapTitle" :headline_text="template.mapDescription" mapDestinationType="Alabama History" ariaLabel="Find an Alabama Sweetspot" />
      <TripIdeas2 v-if="!campaignNotFound" class="" :experience="template.tripIDs"/>
      <Crowdriff
        v-if="template && template.crowdriffID"
        :id="template.crowdriffID"
        :aria-label="page.fields.crowdriff_gallery.aria_label"
        :title="page.fields.crowdriff_gallery.title"
        :intro="page.fields.crowdriff_gallery.intro"
      />
      <CampaignCallout1 v-if="template && template.callout" :callout="template.callout[0]"/>
      <CampaignCallout2 v-if="template && template.callout" :callout="template.callout[1]"/>
    </section>
    <section v-else-if="this.campaignNotFound">
      <NotFoundCampaign  />
    </section>
    <Footer/>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import CampaignHeader from '@/components/Campaigns/CampaignHeader.vue';
import Crowdriff from '@/components/Common/Crowdriff.vue';
import CampaignList from '@/components/Campaigns/CampaignList.vue';
import CampaignCallout1 from '@/components/Campaigns/CampaignCallout1.vue';
import CampaignCallout2 from '@/components/Campaigns/CampaignCallout2.vue';
import TripIdeas2 from '@/components/PlacesToGo/Common/TripIdeas2.vue';
import NotFoundCampaign from '@/components/404/NotFoundCampaign.vue';
import Footer from '@/components/Common/Footer.vue';
import Butter from 'buttercms';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  components: {
    CampaignHeader,
    Crowdriff,
    CampaignList,
    TripIdeas2,
    CampaignCallout1,
    CampaignCallout2,
    NotFoundCampaign,
    Footer,
  },
  data() {
    return {
      page: {
        fields: {},
      },
      template: {},
      loaded: false,
      campaignNotFound: false,
    };
  },
  methods: {
    reloadCampaignMap(bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const params = `&min_latitude=${sw.lat()}&min_longitude=${ne.lng()}&max_latitude=${ne.lat()}&max_longitude=${sw.lng()}`;
      this.getCampaignLocations(params);
    },
    async getCampaignLocations(params) {
      try {
        const utm = this.$route.query.utm_content;
        await axios.get(`${process.env.VUE_APP_API2}getTemplates?utm_content=${utm}${params}`, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Accept: 'application/json',
          },
        }).then((response) => {
          this.$nextTick(() => {
            if (!response.data[0]) {
              this.campaignNotFound = true;
            }
            const tempArray = response.data[0];
            const mapLocations = response.data[0].map_locations;
            if (mapLocations) {
              let count = mapLocations.length;
              let temp;
              let index;
              // shuffle
              while (count > 0) {
              // Pick a random index
                index = Math.floor(Math.random() * count);
                // Decrease count by 1
                count--;
                // And swap the last element with it
                temp = mapLocations[count];
                mapLocations[count] = mapLocations[index];
                mapLocations[index] = temp;
              }
              this.template = tempArray;
              this.template.map_locations = mapLocations.map(location => ({ ...location, show: true }));
            } else {
              this.template.map_locations = [];
            }
            this.loaded = true;
            this.eventNotFound = false;
          });
        });
      } catch {
        this.loaded = true;
        this.campaignNotFound = true;
        console.log('Error pulling template');
      }
    },
    getPage() {
      butter.page
        .retrieve('*', 'sweet-spots', {
          preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
        })
        .then((res) => {
          this.page = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  async created() {
    await this.getCampaignLocations('');
    await this.$store.dispatch('maps/setArea', '');
    await this.getPage();
  },
})
class SweetSpot extends Vue {}

export default SweetSpot;
</script>

<style lang="scss" scoped>

</style>
